import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, ListItem, MenuItem, TextField } from "@mui/material";
import { Modal } from "antd";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from "date-fns";
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from "../../../../auth/auth";
import dayjs from 'dayjs';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getStatus } from "../../../../utils/statusUtils";
import { assignOnBoardingFormToUser, getOnboardingFormsType, removeOnBoardingFormTypeFromUser } from "../../../../api/apiCall";
import EditOnboardingForm from "./EditOnboardingForm/EditOnboardingForms";

const OnboardingForms = ({profileInfo, getWorkerInfo}: any) => {
    const {state} = useAuth();
    const navigate = useNavigate();
    const [isModalOnboardingFormOpen, setIsModalOnboardingFormOpen] = useState(false);
    const [isModalEditOnboardingFormOpen, setIsModalEditOnboardingFormOpen] = useState(false);
    const [onboardingForms, setOnboardingForms] = useState<any>([]);
    const [selectedOnboardingForm, setSelectedOnboardingForm] = useState<any>();
    const [image, setImage] = useState<any>(null);
    const [expDate, setExpDate] = useState<any>(dayjs());
    const [loading, setLoading] = useState(false);
    const [onboardingFormStatus, setOnboardingFormStatus] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [id, setId] = useState<any>('');
    const [, setOpen] = useState(false);

    const onBoardingFormTypes = async () => {
        const response = await getOnboardingFormsType(state.user?.token);
        if(response) {
            setOnboardingForms(response.data);
        }
    }

    useEffect(() => {
        onBoardingFormTypes();
    }, []);

    const handleCancelOnboardingForm = () => {
        setIsModalOnboardingFormOpen(false);
    };

    const handleCancelEditOnboardingFormModal = () => {
        setSelectedOnboardingForm([])
        setIsModalEditOnboardingFormOpen(false);
    };

    const handleImageUpload = (event: any) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const fileArray = Array.from(files);
            setImage(fileArray);
        }
    };

    const addOnboardingForm = async () => {
        setLoading(true);
        const response = await assignOnBoardingFormToUser(state.user?.token, {
            userId: profileInfo.id,
            onBoardingFormTypeId: selectedOnboardingForm.id,
            expDate: format(expDate.$d, 'yyyy-MM-dd'),
            onBoardingFormStatus: onboardingFormStatus,
            onBoardingFormDocuments: image
        })
        if(response) {
            setIsModalOnboardingFormOpen(false);
            toast.success('Onboarding form added successfully');
            getWorkerInfo();
        }
        setLoading(false);
    };

    const handleDelete = async (id: any) => {
        const response = await removeOnBoardingFormTypeFromUser(state.user?.token, id);
        if(response) {
            getWorkerInfo();
        } else {
            toast.error('Something went wrong!')
        }
    };

    const onboardingFormsColumns: any = [
        {
            field: "name",
            headerName: "Onboarding Forms",
            flex: 3,
            renderCell: (params: any) => (
                <div>{params.row.onBoardingFormType.name}</div>
            ),
        },
        {
            field: "expDate",
            headerName: "Expiration Date",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => {
                const today = new Date();
                const expirationDate = new Date(params.row.expDate);

                return (
                    <div style={{
                        color: expirationDate <= today ? 'red' : 'inherit',
                        fontWeight: expirationDate <= today ? 'bold' : 'normal'
                    }}>
                        {format(
                            new Date(params.row.expDate || Date.now()),
                            'dd/MM/yyyy'
                        )}
                    </div>
                );
            },
        },
        {
            field: "status",
            headerName: "Status",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => (
                <div>
                    {getStatus(params.row.status)}
                </div>
            ),
        },
        {
            field: "images",
            headerName: "Images",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => 
                <Button
                    variant="outlined"
                    onClick={() => {
                        navigate("/pace-team/resourcing/get-worker-onboarding-form-documents", {
                            state: { userOnboardingFormId: params.row.id, name: profileInfo?.name, surname: profileInfo?.surname, onboardingFormName: params.row.onBoardingFormType.name
                        }});
                    }}>
                        Documents
                </Button>
        },
        {
            field: "fullName",
            headerName: "Approved By",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
        },
        {
            field: "edit",
            headerName: "Edit",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => 
                <Button
                    variant="contained"
                    style={{backgroundColor: 'gray', boxShadow: 'none'}}
                    onClick={() => {
                        setId(params.id);
                        console.log(params.row)
                        setSelectedOnboardingForm(params.row.onBoardingFormType)
                        setExpDate(dayjs(params.row.expDate))
                        setOnboardingFormStatus(params.row.status)
                        setIsModalEditOnboardingFormOpen(true)
                    }}
                    >
                        Edit
                </Button>
        },
        {
            field: "delete",
            headerName: "Delete",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Button
                    variant="contained"
                    color="error"
                    style={{boxShadow: 'none'}}
                    onClick={() => {
                        setOpen(true);
                        Modal.confirm({
                            title: `Are you sure you want to delete ${params.row.onBoardingFormType.name}?`,
                            onOk: () => handleDelete(params.id),
                            okButtonProps: { danger: true },
                            okText: 'YES',
                            cancelText: 'NO',
                            centered: true
                        });
                    }}
                >
                    Delete
                </Button>
            )
        }
    ];

    const filteredOnboardingForms = profileInfo?.onBoardingForms
  ? profileInfo.onBoardingForms.filter((onboardingForm: any) =>
      onboardingForm?.onBoardingFormType?.name
        ?.toLowerCase()
        .includes(searchTerm?.toLowerCase() || "")
    )
  : [];

    return (
        <>
            <Box display="flex" justifyContent="right" alignItems="center" mb={2}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {setIsModalOnboardingFormOpen(true)}}
                    style={{ width: 230, boxShadow: "none" }}
                >
                    Add Onboarding Form
                </Button>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={2}>
                <h2>Onboarding Forms</h2>
                <TextField
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    style={{width: 300}}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </Box>
            <Box>
                <DataGrid
                    rows={filteredOnboardingForms || []}
                    columns={onboardingFormsColumns}
                    style={{height: 474}}
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15.5,
                        }
                    }}
                />
            </Box>
            <Modal
                title={`Add Onboarding Form for ${profileInfo?.name} ${profileInfo?.surname}`}
                onCancel={handleCancelOnboardingForm}
                open={isModalOnboardingFormOpen}
                footer={[
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button variant="contained" sx={{ boxShadow: 'none', mb: 2 }} onClick={addOnboardingForm} disabled={loading}>
                            Add Onboarding Form
                        </Button>
                    </div>
                ]}>
                <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr" }} gap={4} mt={4}>
                    <Autocomplete
                        size="small"
                        options={onboardingForms}
                        onChange={(_, newValue) => {
                            setSelectedOnboardingForm(newValue)
                        }}
                        getOptionLabel={(option: any) => option.name}
                        renderOption={(props, option) => (
                            <ListItem {...props} key={option.name}>
                              {option.name}
                            </ListItem>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Onboarding Form" placeholder="Select Onboarding Form" />
                        )}
                    />
                    <TextField
                        type="file"
                        variant="outlined"
                        fullWidth
                        onChange={handleImageUpload}
                        size="small"
                        inputProps={{
                            multiple: true,
                            accept: ".jpg,.jpeg,.png,.gif,.bmp,.tiff,.xls,.xlsx,.doc,.docx,.pdf"
                        }}
                        sx={{
                            '& input[type="file"]::file-selector-button': {
                                backgroundColor: '#e3e3e3',
                                color: '#000',
                                border: 'none',
                                padding: '4px 12px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s',
                            },
                        }}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                slotProps={{textField: { size: 'small', fullWidth: true }}}
                                label="Experation Date"
                                value={expDate}
                                format="DD/MM/YYYY"
                                onChange={(value) => {setExpDate(value)}}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                     <TextField
                        select
                        value={onboardingFormStatus}
                        id="demo-select-small"
                        size="small"
                        label="Status"
                        sx={{mb: 4}}
                        onChange={(e: any) => {setOnboardingFormStatus(e.target.value)}}
                    >
                        <MenuItem value={0}>Pending</MenuItem>
                        <MenuItem value={1}>Approved</MenuItem>
                        <MenuItem value={2}>Denied</MenuItem>
                        <MenuItem value={3}>Not Verified</MenuItem>
                    </TextField>
                </Box>
            </Modal>
            <Modal
                title={`Edit Onboarding Form for ${profileInfo?.name} ${profileInfo?.surname}`}
                onCancel={handleCancelEditOnboardingFormModal}
                open={isModalEditOnboardingFormOpen}
                footer={[]}>
                    <EditOnboardingForm
                        id={id}
                        profileInfo={profileInfo}
                        onboardingForms={onboardingForms}
                        selectedOnboardingForm={selectedOnboardingForm}
                        setSelectedOnboardingForm={setSelectedOnboardingForm}
                        expDate={expDate}
                        setExpDate={setExpDate}
                        onboardingFormStatus={onboardingFormStatus}
                        setOnboardingFormStatus={setOnboardingFormStatus}
                        setIsModalEditOnboardingFormOpen={setIsModalEditOnboardingFormOpen}
                        getWorkerInfo={getWorkerInfo}
                    />
                </Modal>
        </>
    )
}

export default OnboardingForms;
